function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { __DEV__ } from "@chakra-ui/utils";
import * as React from "react";
import { Transition } from "./transition";
var styles = {
  init: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  }
};
export var Fade = function Fade(props) {
  var _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 150 : _props$timeout,
      rest = _objectWithoutPropertiesLoose(props, ["timeout"]);

  return /*#__PURE__*/React.createElement(Transition, _extends({
    transition: "all " + timeout + "ms cubic-bezier(0.175, 0.885, 0.320, 1.175)",
    styles: styles,
    timeout: {
      enter: 0,
      exit: timeout
    }
  }, rest));
};

if (__DEV__) {
  Fade.displayName = "Fade";
}